<template>
  <div class="profile-page">
    <AppSectionHero
      title="Profile"
      subtitle="Review the account information loaded from the current signed-in session."
      :show-refresh="false"
    />

    <CRow>
      <CCol lg="8" class="mb-4">
        <CCard class="border-0 shadow-sm h-100">
          <CCardHeader class="bg-white border-0 pt-4 px-4">
            <div class="section-title">Identity</div>
          </CCardHeader>
          <CCardBody class="pt-0 px-4 pb-4">
            <CRow>
              <CCol md="6" class="mb-3">
                <div class="field-label">Display name</div>
                <div class="field-value">{{ displayName }}</div>
              </CCol>
              <CCol md="6" class="mb-3">
                <div class="field-label">Email</div>
                <div class="field-value">{{ email }}</div>
              </CCol>
              <CCol md="6" class="mb-3">
                <div class="field-label">Role</div>
                <div class="field-value">{{ roleLabel }}</div>
              </CCol>
              <CCol md="6" class="mb-3">
                <div class="field-label">Account ID</div>
                <div class="field-value field-value-mono">{{ accountId }}</div>
              </CCol>
              <CCol md="12">
                <div class="field-label">Status</div>
                <div class="field-value">{{ statusLabel }}</div>
              </CCol>
            </CRow>
          </CCardBody>
        </CCard>
      </CCol>

      <CCol lg="4" class="mb-4">
        <CCard class="border-0 shadow-sm h-100">
          <CCardHeader class="bg-white border-0 pt-4 px-4">
            <div class="section-title">Quick Actions</div>
          </CCardHeader>
          <CCardBody class="pt-0 px-4 pb-4">
            <div class="action-item" @click="$router.push('/general/preferences')">
              <CIcon name="cil-settings" class="mr-2 text-warning" />
              <span>Open preferences</span>
            </div>
            <div class="action-item" @click="$router.push('/notifications')">
              <CIcon name="cil-bell" class="mr-2 text-danger" />
              <span>View notifications</span>
            </div>
            <div class="action-item" @click="$router.push('/dashboard')">
              <CIcon name="cil-speedometer" class="mr-2 text-primary" />
              <span>Back to dashboard</span>
            </div>
          </CCardBody>
        </CCard>
      </CCol>
    </CRow>
  </div>
</template>

<script>
import AppSectionHero from '@/projects/components/layout/AppSectionHero'
import { getRoleLabel, getWorkspaceRole } from '@/utils/role-dashboard'

function pickText(value) {
  if (!value) return ''
  if (typeof value === 'string') return value.trim()
  if (Array.isArray(value)) {
    const found = value.find(item => item && item.value)
    return found && found.value ? String(found.value).trim() : ''
  }
  if (typeof value === 'object') {
    return String(value.value || value.name || value.label || '').trim()
  }
  return ''
}

export default {
  name: 'ProfilePage',
  components: {
    AppSectionHero
  },
  computed: {
    profile() {
      return this.$store.getters['auth/profile'] || {}
    },
    displayName() {
      const userinfo = this.profile.userinfo || {}
      const prefix = pickText(userinfo.prefix)
      const firstName = pickText(userinfo.firstName) || pickText(this.profile.firstName)
      const lastName = pickText(userinfo.lastName) || pickText(this.profile.lastName)
      return [prefix, firstName, lastName].filter(Boolean).join(' ').trim() || this.profile.email || 'User'
    },
    email() {
      return this.profile.email || '-'
    },
    roleLabel() {
      return getRoleLabel(getWorkspaceRole(this.$store))
    },
    accountId() {
      return this.profile._id || this.profile.id || '-'
    },
    statusLabel() {
      const status = this.profile.status || {}
      return pickText(status.title) || status.key || '-'
    }
  }
}
</script>

<style scoped>
.section-title {
  color: #344767;
  font-size: 1.2rem;
  font-weight: 700;
}
.field-label {
  color: #8a8f98;
  font-size: 0.8rem;
  font-weight: 700;
  letter-spacing: 0.04em;
  margin-bottom: 0.35rem;
  text-transform: uppercase;
}
.field-value {
  color: #344767;
  font-size: 1rem;
  font-weight: 600;
}
.field-value-mono {
  font-family: Menlo, Monaco, Consolas, monospace;
  font-size: 0.88rem;
}
.action-item {
  align-items: center;
  border-top: 1px solid #eef1f6;
  cursor: pointer;
  display: flex;
  padding: 1rem 0;
}
</style>
